import { render, staticRenderFns } from "./DashboardTodayAudits.vue?vue&type=template&id=5937e0e4"
import script from "./DashboardTodayAudits.vue?vue&type=script&lang=ts"
export * from "./DashboardTodayAudits.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports